import Component from "../../classes/Component";
import {$events} from "../../helpers/events";
import {$dom} from "../../helpers/dom";
import variables from "../../variables";

const {getAll} = $dom

const containerSelector = '.js-container'

export default function () {
    const handleResize = () => {
        getAll(containerSelector).forEach(item => {
            let widthOfContainer;

            if (variables.windowWidth >= 1400) widthOfContainer = 1200
            if (variables.windowWidth < 1400 && variables.windowWidth > 1200) widthOfContainer = 1140
            if (variables.windowWidth < 1200 && variables.windowWidth > 990) widthOfContainer = 960
            if (variables.windowWidth < 990 && variables.windowWidth > 767) widthOfContainer = 720
            if (variables.windowWidth < 767) widthOfContainer = variables.windowWidth + 30

            const marginLeft = (variables.windowWidth - widthOfContainer + 30) / 2
            item.style.marginLeft = marginLeft + 'px'
        })
    }

    return new Component({
        name: 'container',
        requiredTargets: [containerSelector],
        onInit() {
            handleResize()

            $events.delegate.on('resize', window, handleResize)
        },
        onDestroy() {
            $events.delegate.off('resize', window, handleResize)
        },
    })

}